import { XIcon, Dumbbell, ArrowUp } from "lucide-react";
import { animate, stagger } from "motion";
import { splitText } from "motion-plus";
import { useEffect, useRef, useState } from "react";
import * as motion from "motion/react-client";

export default function MotionSplitText({
  data,
}: {
  data: {
    text: string;
    extracted: { exercise: string; weight: string; reps: number };
    avatar: string;
  };
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  //const [showStats, setShowStats] = useState(false);

  const duration = 3;
  useEffect(() => {
    //setShowStats(false);
    document.fonts.ready.then(() => {
      if (!containerRef.current) return;
      containerRef.current.style.visibility = "visible";
      const { words } = splitText(containerRef.current.querySelector("h3")!);
      animate(
        words,
        { opacity: [0, 1], y: [10, 0] },
        {
          type: "spring",
          duration: duration,
          bounce: 0.3,
          delay: stagger(0.05),
        }
      );
      //setTimeout(() => setShowStats(true), (duration - 0.5) * 1000);
    });
  }, [data.text]);

  return (
    <div className="flex flex-col">
      <div
        className="split-container items-center transition-transform duration-500"
        ref={containerRef}
        key={data.text}
      >
        <h3 className="text-tx-default font-playpen">"{data.text}"</h3>
        <Stylesheet />
      </div>
    </div>
  );
}

function Stylesheet() {
  return (
    <style>{`
    
            .split-container {
                display: flex;
                justify-content: center;
                align-items: center;
                min-height: 64px;
                max-width: 420px;
                text-align: center;
                visibility: hidden;
            }
        `}</style>
  );
}
